import { render, staticRenderFns } from "./ReviewInternalApiHarvester.vue?vue&type=template&id=580305a5&"
import script from "./ReviewInternalApiHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewInternalApiHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports